module.exports = __webpack_public_path__ + "img/icon_download_apk.08b22db5.svg";